<app-news-link [news]="news" [utmParams]="utmParams">
  <lib-content-card
    [showVideoIndicator]="news.videos_native?.length > 0"
    [colorScheme]="colorScheme"
    [title]="title"
    [layout]="layout"
    [preTitle]="preTitle"
    [picture]="picture"
    [lazyLoadImage]="lazyLoadImage"
    [preloadImage]="preloadImage"
    [containImage]="containImage"
    [imageResolution]="imageResolution"
    [minImageHeight]="minImageHeight"
    [maxImageHeight]="maxImageHeight"
    [aspectRatio]="aspectRatio"
    [splitAlignment]="splitAlignment">
  </lib-content-card>
</app-news-link>
